import React, { useState, useEffect } from "react";
import "./Financials.css";
import MAndATimeline from "./MAndATimeline";
import VendorMap from "./VendorMap";
import TopRightActionLinks from "../../TopRightActionLinks";
import InsightBlock from "../../InsightBlock";
import SingleColumnChart from "../../../../HtmlElements/SingleColumnChart";
import MultiLineChart from "../../../../HtmlElements/MultiLineChart";
import FinancialTrends from "./FinancialTrends";
import GroupedColumnChart from "../../../../HtmlElements/GroupedColumnChart";
import GenericOverviewSideCard from "../../../genericComponents/GenericOverviewSideCard";
import AIChat from "../../../Chat/AiChat";
import FinancialsGiq from "../../Financials/FinancialsGiq";
import { useParams } from "react-router-dom";
import { useCompetitorContext } from "../../../../../context/CompetitorContext";

function FinancialsComp({
  activeSubKey,
  setActiveSubKey,
  compView,
  dataReportCheck,
  subItemDataStatus,
  registerDynamicTabs,
  scrollContainerRef,
}) {
  const [showConversationModal, setShowConversationModal] = useState(false);
  const { clientName, competitorName } = useParams();
  const { competitorInfo } = useCompetitorContext();

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // {
    //   type: "conversation",
    //   title: "Conversation",
    //   onClick: () => {
    //     setShowConversationModal((prev) => !prev);
    //   },
    // },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    // { type: "download", title: "Download", onClick: () => {} },
  ];

  const chartData = [
    { year: "2019", gross: 25, operating: 14, net: 9 },
    { year: "2020", gross: 25, operating: 14, net: 9 },
    { year: "2021", gross: 25, operating: 14, net: 9 },
    { year: "2022", gross: 25, operating: 14, net: 9 },
  ];

  return (
    <div className="finacial_wrapper">
      <div className="finacial_headblock">
        <div className="finacial_subheadblock">
          {/* <h5 className="finacial_head">Financial Performance</h5> */}
          <h5 className="finacial_head">Strategic & Financial Performance</h5>
          {subItemDataStatus.financialsTable && (
            <p className="finacial_para">
              Benchmark strategic alignment and financial health
            </p>
          )}
        </div>
        <div className="finacial_btn_block">
          <TopRightActionLinks actions={actions} />
        </div>
      </div>

      {/* <div>
        <InsightBlock
          title={""}
          overview={""}
          actions={[]}
          pagePositives={[]}
          pageNegatives={[]}
          pageSoWhat={[]}
        />
      </div> */}

      {/* <div className="revenue_breakdown_wrapper">
        <div className="revenue_breakdown_headblock">
          <div className="revenue_breakdown_subheadblock">
            <h5 className="revenue_breakdown_head">Revenue Breakdown</h5>
            <p className="revenue_breakdown_para">
              Comparison of brand messaging, value propositions, and campaign
              themes shaping market perception across leading competitors.
            </p>
          </div>
          <div className="revenue_breakdown_btn_block">
            <TopRightActionLinks actions={actions} />
          </div>
        </div>
        <div className="revenue_chart_block">
          <SingleColumnChart />
        </div>
      </div> */}

      {/* <div className="finacial_trends_wrapper">
        <div className="finacial_trends_headblock">
          <div className="finacial_trends_subheadblock">
            <h5 className="finacial_trends_head">Financial Trends</h5>
            <p className="finacial_trends_para">
              Comparison of brand messaging, value propositions, and campaign
              themes shaping market perception across leading competitors.
            </p>
          </div>
          <div className="finacial_trends_btn_block">
            <TopRightActionLinks actions={actions} />
          </div>
        </div>
        <div className="finacial_trends_block">
          <FinancialTrends />
        </div>
      </div> */}

      {/* <div className="profit_snapshot_wrapper">
        <div className="profit_snapshot_headblock">
          <div className="profit_snapshot_subheadblock">
            <h5 className="profit_snapshot_head">Profit Snapshot</h5>
            <p className="profit_snapshot_para">
              Comparison of brand messaging, value propositions, and campaign
              themes shaping market perception across leading competitors.
            </p>
          </div>
          <div className="profit_snapshot_btn_block">
            <TopRightActionLinks actions={actions} />
          </div>
        </div>
        <div className="profit_snapshot_block">
          <GroupedColumnChart data={chartData} />
        </div>
      </div> */}

      {/* <div className="global_footprint_wrapper">
        <div className="global_footprint_headblock">
          <div className="global_footprint_subheadblock">
            <h5 className="global_footprint_head">Global Footprint</h5>
            <p className="global_footprint_para">
              Distribution of Siemens' operational presence across geographies
              and functions.
            </p>
          </div>
          <div className="global_footprint_btn_block">
            <TopRightActionLinks actions={actions} />
          </div>
        </div>
        <div className="global_footprint_block">
          <img
            src="/img/revenue_chart3.png"
            className="global_footprint_img"
            alt="chart_img"
          />
        </div>
      </div> */}

      {/* <MAndATimeline /> */}
      {/* <VendorMap /> */}
      <div className="finacials_wrapper">
        <FinancialsGiq
          activeSubKey={activeSubKey}
          setActiveSubKey={setActiveSubKey}
          compView={compView}
          dataReportCheck={dataReportCheck}
          competitorInfo={competitorInfo}
          registerDynamicTabs={registerDynamicTabs}
          scrollContainerRef={scrollContainerRef}
        />
      </div>

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This:{" "}
                    {competitorName ?? "Tailored Chemical Products"} - Market
                    Insights
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={""} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </div>
  );
}

export default FinancialsComp;
